import {
  BriefcaseBusiness,
  ClipboardList,
  FileSearch,
  FileText,
  Handshake,
  MapPinned,
  PhoneCall,
  Presentation,
  Search,
  ShieldCheck,
  Target,
  TrendingUp,
} from "lucide-react";

const ICON_CATALOG = [
  {
    value: "briefcase-business",
    label: "Geral",
    icon: BriefcaseBusiness,
    keywords: ["geral", "atividade", "tarefa"],
  },
  {
    value: "phone-call",
    label: "Ligacao",
    icon: PhoneCall,
    keywords: ["ligacao", "ligar", "telefone", "call"],
  },
  {
    value: "map-pin",
    label: "Visita",
    icon: MapPinned,
    keywords: ["visita", "presencial", "campo", "rota"],
  },
  {
    value: "search",
    label: "Pesquisa",
    icon: Search,
    keywords: ["pesquisa", "levantamento", "mapeamento", "mercado"],
  },
  {
    value: "handshake",
    label: "Parceria",
    icon: Handshake,
    keywords: ["parceria", "negociacao", "acordo", "fechamento"],
  },
  {
    value: "presentation",
    label: "Reuniao",
    icon: Presentation,
    keywords: ["reuniao", "apresentacao", "demo", "alinhamento"],
  },
  {
    value: "file-text",
    label: "Documento",
    icon: FileText,
    keywords: ["documento", "contrato", "proposta", "formulario"],
  },
  {
    value: "clipboard-list",
    label: "Checklist",
    icon: ClipboardList,
    keywords: ["checklist", "rotina", "acompanhamento", "follow"],
  },
  {
    value: "target",
    label: "Meta",
    icon: Target,
    keywords: ["meta", "objetivo", "oportunidade", "lead"],
  },
  {
    value: "shield-check",
    label: "Validacao",
    icon: ShieldCheck,
    keywords: ["validacao", "aprovacao", "checagem", "auditoria"],
  },
  {
    value: "trending-up",
    label: "Comercial",
    icon: TrendingUp,
    keywords: ["comercial", "venda", "producao", "resultado"],
  },
  {
    value: "file-search",
    label: "Diagnostico",
    icon: FileSearch,
    keywords: ["diagnostico", "analise", "estudo", "investigacao"],
  },
];

function normalizeToken(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

function findIconByValue(iconValue) {
  const normalizedValue = normalizeToken(iconValue);
  if (!normalizedValue) return null;
  return ICON_CATALOG.find((item) => item.value === normalizedValue) || null;
}

function findIconByName(nomeTipo) {
  const normalizedName = normalizeToken(nomeTipo);
  if (!normalizedName) return null;
  return (
    ICON_CATALOG.find((item) =>
      item.keywords.some((keyword) => normalizedName.includes(normalizeToken(keyword)))
    ) || null
  );
}

export const TASK_TYPE_ICON_OPTIONS = ICON_CATALOG.map((item) => ({
  value: item.value,
  label: item.label,
}));

export function resolveTaskTypeIconDefinition(tipoOrIconValue, nomeTipo = "") {
  const explicitIconValue =
    typeof tipoOrIconValue === "string" ? tipoOrIconValue : tipoOrIconValue?.icone;
  const explicitMatch = findIconByValue(explicitIconValue);
  if (explicitMatch) return explicitMatch;

  const fallbackName =
    typeof tipoOrIconValue === "object" ? tipoOrIconValue?.nomeTipo : nomeTipo;
  return findIconByName(fallbackName) || ICON_CATALOG[0];
}
